import React, { Component } from 'react'
import { Dropdown } from 'react-bootstrap'

import Profile from './profile'
import ProfileMenu from './profileMenu'

export default class TopBar extends Component {
  navToggle(e) {
    if(document.body.classList.contains('nav-md')) {
      document.body.classList.remove('nav-md')
      document.body.classList.add('nav-sm')
    } else {
      document.body.classList.remove('nav-sm')
      document.body.classList.add('nav-md')
    }
  }

  render() {
    return (
      <div className="top_nav hidden-print">
        <div className="nav_menu">
          <nav>
            <div className="nav toggle" onClick={ this.navToggle.bind(this) }>
              <a id="menu_toggle"><i className="fa fa-bars"></i></a>
            </div>
            <ul className="nav navbar-nav navbar-right">
                <Dropdown id="user-profile-menu" componentClass="li">
                  <Profile bsRole="toggle" componentClass="a" />
                  <ProfileMenu bsRole="menu" componentClass="ul" />
                </Dropdown>
            </ul>
          </nav>
        </div>
      </div>
    )

    /*
    <li>
      <Dropdown id="user-profile-menu" componentclassName="a">
        <Profile bsRole="toggle" componentclassName="a" />
        <ProfileMenu bsRole="menu" componentclassName="ul" />
      </Dropdown>
    </li>


    <a href="javascript:;" className="user-profile dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
      <img src="images/img.jpg" alt="" />John Doe
      <span className=" fa fa-angle-down"></span>
    </a>
    */
  }
}



// WEBPACK FOOTER //
// ./src/components/topbar.js